import { render } from "./YouTubeGallery.vue?vue&type=template&id=09a54bc8&scoped=true"
import script from "./YouTubeGallery.vue?vue&type=script&lang=js"
export * from "./YouTubeGallery.vue?vue&type=script&lang=js"

import "./YouTubeGallery.vue?vue&type=style&index=0&id=09a54bc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09a54bc8"

export default script